import { AfterContentInit, Component, ElementRef, HostBinding, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { ThemeService } from 'src/app/services/theme/theme.service';
import { Saving } from '../../../../../models/product';
import { UpperCasePipe } from '@angular/common';
import { PriceFieldComponent } from '../../price-field/price-field.component';

export type SavingsPosition = 'left' | 'right';

@Component({
  selector: 'app-savings',
  templateUrl: './savings.component.html',
  styleUrls: ['./savings.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [UpperCasePipe, PriceFieldComponent],
})
export class SavingsComponent implements AfterContentInit {
  private themeService = inject(ThemeService);
  private elRef = inject(ElementRef);

  @Input() savings: Saving;

  ngAfterContentInit() {
    this.themeService.subscribeComponent(this.elRef);
  }

  @Input() position: SavingsPosition = 'right';
  @HostBinding('class.right') get right() {
    return this.position === 'right';
  }
  @HostBinding('class.left') get left() {
    return this.position === 'left';
  }
}
